import * as React from 'react';
import {
    Edit,
    TextInput,
    SimpleForm,
    required,
    ReferenceInput,
    AutocompleteInput,
} from 'react-admin';
import { Page } from '../types';

import Aside from './Aside';
import FullNameField from './FullNameField';

const req = [required()];

const EntityEdit = () => {
    const optionRenderer = (choice: Page) =>
        `${choice.title_selector} (${choice.geo_id}/${choice.fias_id})`;
    const dataTransform = (data: Page) => ({
        ...data,
        type: 'override',
    });

    return (
        <Edit
            title={<EditTitle />}
            resource="logix_geo_map_overrides"
            aside={<Aside />}
            redirect={false}
            mutationMode="pessimistic"
            transform={dataTransform}
        >
            <SimpleForm>
                <ReferenceInput
                    source="from_geo_id"
                    reference="logix_cities"
                    filter={{ type: 'locality' }}
                >
                    <AutocompleteInput
                        optionText={optionRenderer}
                        validate={req}
                        fullWidth
                        isRequired
                    />
                </ReferenceInput>
                <ReferenceInput source="to_geo_id" reference="logix_cities">
                    <AutocompleteInput
                        optionText={optionRenderer}
                        fullWidth
                        validate={req}
                        isRequired
                    />
                </ReferenceInput>
                <TextInput source="description" fullWidth />
            </SimpleForm>
        </Edit>
    );
};

// @ts-ignore
const EditTitle = () => <FullNameField size="32" sx={{ margin: '5px 0' }} />;

export default EntityEdit;
